import React from 'react';
import { Grid, Col } from '@bit/knotchinc.web-react-components.grid';
import { inPercent, formatterWithWord, numberWithCommas } from 'helpers/Utils.js';
import { REPORT_GRID_STYLE, findMaxItems, calculateRowHeight } from 'components/Pages/Reports/helpers.js';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import EntityItemWithContent from 'components/Global/EntityItem/EntityItemWithContent.jsx';
import { ListTitle, SocialListContainer, SocialShareWrapper, ListBarContainer, Section } from 'components/Pages/Reports/styled.js';
import ReportLeaderboard from 'components/Pages/Reports/ReportLeaderboard/ReportLeaderboard.jsx';
import { ContentSharesOverviewRow } from 'components/Pages/Reports/EntityOverview/rows';
import ErrorEntityListCard from 'components/Pages/Reports/ErrorStates/ErrorEntityListCard.jsx';
import EntityOverview from './EntityOverview.jsx';
import PageLayoutGenerator from './PageLayoutGenerator.jsx';

const SocialReportTab = ({ report: {
      social: {
      entities_by_num_shares,
      top_content_by_shares,
      top_content_by_entities,
      top_entities_by_num_shares,
    },
    request: { report_type: reportType },
  },
}) => {
  const maxEntities = findMaxItems([entities_by_num_shares, top_content_by_shares]);
  const rowHeight = calculateRowHeight(maxEntities, 'social');

  return (
    <React.Fragment>
      <PageLayoutGenerator>
        <Section>
          <ListTitle>SOCIAL PERFORMANCE OVERVIEW</ListTitle>
          <ReportLeaderboard type="social" data={top_entities_by_num_shares} />
        </Section>
        <Section>
          <ListTitle>SOCIAL PERFORMANCE COMPARISON</ListTitle>
          <Grid height={rowHeight} gridStyle={REPORT_GRID_STYLE}>
            <Col>
              {entities_by_num_shares.length > 0 ? (
                <SocialListContainer>
                  <ListTitle>TOTAL SHARES</ListTitle>
                  {entities_by_num_shares.map((entity, idx) => (
                    <ListBarContainer key={`${entity.public_id}-${idx}`}>
                      <EntityItem data={entity} hideName />
                      <HorizontalFillBar
                        fillPct={inPercent(entity.pct_num_shares, 1, true)}
                        label={<EntityItem data={entity} hideIcon />}
                        value={entity.num_shares}
                        stacked
                        pctWidth="100%"
                        labelWidth={'30%'}
                      />
                    </ListBarContainer>
                  ))}
                </SocialListContainer>
            ) : (
              /* If entities_by_num_shares is empty - Error State */
              <ErrorEntityListCard title="Total Shares" />
            )}
            </Col>
            <Col weight={2}>
              <SocialShareWrapper>
                {top_content_by_shares.length > 0 ? (
                  <SocialListContainer>
                    <ListTitle>TOP CONTENT BY SHARES</ListTitle>
                    {top_content_by_shares.map((data, idx) => (
                      <ListBarContainer key={`${data[reportType].public_id}-${idx}`}>
                        <EntityItem data={data[reportType]} hideName />
                        <HorizontalFillBar
                          fillPct={inPercent(data.pct_num_shares, 1, true)}
                          label={<EntityItemWithContent entity={data[reportType]} data={data} hideIcon />}
                          value={formatterWithWord('Shares', numberWithCommas)(data.num_shares)}
                          stacked
                          pctWidth="100%"
                          labelWidth={'30%'}
                        />
                      </ListBarContainer>
                    ))}
                  </SocialListContainer>
              ) : (
                /* If top_content_by_shares is empty - Error State */
                <ErrorEntityListCard title="Top content by shares" />
              )}
              </SocialShareWrapper>
            </Col>
          </Grid>
        </Section>
      </PageLayoutGenerator>
      <EntityOverview
        title={`${reportType}S' TOP CONTENT PIECES BY SHARES`}
        data={top_content_by_entities}
        Row={ContentSharesOverviewRow}
        type="social"
        entityType={reportType}
      />
    </React.Fragment>
  );
};

export default SocialReportTab;
